import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Icons } from 'sarsaparilla';
import { addChange, clearChange, getRef } from '../../actions/changes';
import { InputPicker, Types } from '../../components/StewardAssetEdit/InputPicker';
import { ImageProps } from '../../props/image';

import pageStyles from './StewardAssetEditPage.scss';

const propTypes = {
  value: ImageProps,
  mediaType: PropTypes.string,
  onRemove: PropTypes.func,
  getRef: PropTypes.func.isRequired,
  addChange: PropTypes.func.isRequired,
  clearChange: PropTypes.func.isRequired
};

const inputs = [
  {
    type: Types.TEXT,
    label: 'Image URL',
    required: false,
    field: 'url'
  },
  {
    type: Types.FILE,
    label: 'Upload Image',
    required: false,
    fileTypes: 'image/jpeg, image/png',
    field: 'image'
  },
  {
    type: Types.TEXT,
    label: 'Image Title',
    required: true,
    field: 'title'
  },
  {
    type: Types.TEXT,
    label: 'Image Subtitle',
    field: 'subtitle'
  },
  {
    type: Types.TEXT,
    label: 'Image Credits',
    field: 'credits'
  },
  {
    type: Types.BLANK,
    field: 'spacing-for-dimensions'
  },
  {
    type: Types.TEXT,
    label: 'Image Width',
    field: 'width'
  },
  {
    type: Types.TEXT,
    label: 'Image Height',
    field: 'height'
  },
  {
    type: Types.TEXTBOX,
    label: 'Image Description',
    fullWidth: true,
    field: 'description'
  },
  {
    type: Types.CHECKBOX,
    label: 'Primary/Header Image',
    field: 'isPrimary'
  },
  {
    type: Types.CHECKBOX,
    label: 'Use For Preview',
    field: 'isPreview'
  },
  {
    type: Types.CHECKBOX,
    label: 'Include In Gallery',
    field: 'isGallery'
  }
];

export class ImageEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      record: this.props.value,
      ref: this.props.getRef(
        this.props.mediaType,
        { id: this.props.value.id, type: 'Image' },
        0,
        ['title'].reduce((m, f) => Object.assign(m, { [f]: props.value[f] }), {})
      )
    };

    this.handleChange = this.handleChange.bind(this);
    this.doRemove = this.doRemove.bind(this);
  }

  handleChange(event) {
    const { dataset: { field }, value: fieldValue } = event.target;

    let value;

    // Handle special case for height and width
    if (field === 'height' || field === 'width') {
      value = parseInt(fieldValue, 10);
    }
    else {
      value = fieldValue;
    }

    const change = { [field]: value };

    this.setState((prevState) => ({
      ...prevState,
      record: { ...prevState.record, ...change }
    }), () => this.props.addChange(this.state.ref, change));
  }

  doRemove() {
    if (this.props.value.id) {
      this.props.addChange(this.state.ref, { _delete: true });
    }
    else {
      this.props.clearChange(this.state.ref);
    }
    this.props.onRemove(this.props.value._key);
  }

  render() {
    const { record, ref } = this.state;

    return (
      <div className={pageStyles['section-box']}>
        <Button
          appearance="subtle-danger"
          onClick={this.doRemove}
          className={pageStyles['delete-button']}
          iconBeforeElement={<Icons.IconClose />} />
        {inputs.map((input) => InputPicker(input, ref, record, this.handleChange))}
      </div>
    );
  }
}

ImageEdit.propTypes = propTypes;

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getRef,
  addChange,
  clearChange
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ImageEdit);
